import { createQuery } from "react-query-kit";
import { api } from "../../api";
import {
  AvailabilityCalendarRequest,
  AvailabilityCalendarResponse,
} from "../../../../../api-contracts/sites/wbe/availability-calendar";

// POST /api/public/availability-calendar/:siteId
export const useGetAvailabilityCalendar = createQuery<
  AvailabilityCalendarResponse,
  AvailabilityCalendarRequest & { siteId: string }
>({
  queryKey: ["useGetAvailabilityCalendar"],
  fetcher: async ({
    siteId,
    queryFromDate,
    queryToDate,
    languageCode,
    guests,
    adIds,
    packageAdId,
    preview,
    partyIsOneUnit,
  }) => {
    return api.post<AvailabilityCalendarResponse>(
      `/api/public/availability-calendar/${siteId}`,
      {
        queryFromDate,
        queryToDate,
        languageCode,
        guests,
        adIds,
        packageAdId,
        preview,
        partyIsOneUnit,
      },
    );
  },
});
